import { useEffect, RefObject } from 'react';

interface UseClickOutsideProps {
    refs: RefObject<HTMLElement>[];
    isOpen: boolean;
    onClickOutside: () => void;
}

export const useClickOutside = ({
    refs,
    isOpen,
    onClickOutside,
}: UseClickOutsideProps) => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (!isOpen) return;

            const clickedOutside = refs.every(
                (ref) =>
                    ref.current && !ref.current.contains(event.target as Node),
            );

            if (clickedOutside) {
                onClickOutside();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, refs, onClickOutside]);
};
